module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("平安合作配置")]), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 0 ? 'primary' : 'plain'
    },
    on: {
      "click": _vm.clickHomeConfig
    }
  }, [_vm._v("首页配置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 1 ? 'primary' : 'plain'
    },
    on: {
      "click": _vm.clickMedalConfig
    }
  }, [_vm._v("勋章配置")])], 1), _vm._v(" "), (_vm.currentIndex == 0) ? _c('HomeConfiguration', {
    ref: "homeRef"
  }) : _vm._e(), _vm._v(" "), (_vm.currentIndex == 1) ? _c('MedalConfiguration', {
    ref: "medalRef"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35e3a1e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/PingAn/CooperationConfig.vue
// module id = 985
// module chunks = 0